const VALID_HEX_6 = /^#?[0-9A-Fa-f]{6}$/;
const VALID_ALPHA_BYTE = /^[0-9A-Fa-f]{2}$/;

/**
 * Alpha byte (AA in #RRGGBBAA) for selected-spot fill — ~15% opacity (matches prior round(0.15 * 255) = 38 = 0x26).
 * Shared by grid cells and legend so they stay visually aligned.
 */
export const SELECTED_SPOT_FILL_ALPHA_HEX = '26';

/**
 * Returns true if the value is a valid 6-digit hex color (with or without #).
 */
export function isValidHexColor(color: string | null | undefined): color is string {
  if (typeof color !== 'string' || color.trim() === '') return false;
  return VALID_HEX_6.test(color.trim());
}

/**
 * Normalizes 6-digit hex to #RRGGBB form.
 */
export function normalizeHex(hex: string): string {
  const t = hex.trim().replace(/^#/, '');
  return t.length === 6 ? `#${t}` : hex;
}

/**
 * Returns 6-digit hex with alpha as #RRGGBBAA (CSS / React Native supported).
 * `alphaHex` is two hex digits (e.g. `'26'` for ~15% opacity). Invalid body or alpha returns `hex` unchanged.
 */
export function hexWithAlpha(hex: string, alphaHex: string): string {
  const trimmed = hex.replace(/^#/, '');
  if (trimmed.length !== 6 || !/^[0-9A-Fa-f]{6}$/.test(trimmed)) return hex;
  const aa = alphaHex.trim().replace(/^#/, '');
  if (!VALID_ALPHA_BYTE.test(aa)) return hex;
  return `#${trimmed}${aa.toLowerCase()}`;
}
